import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppButton = () => (
  <a
    href="https://wa.link/4ryenn"
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 left-6 bg-h-gold text-h-navy p-3 rounded-full shadow-lg hover:opacity-80 z-40"
  >
    <FaWhatsapp size={28} />
  </a>
);
